module.exports = __webpack_public_path__ + "static/media/image-money-stack@3x.02cbb9a3.png";